import { attr, many, oneToOne, fk } from 'redux-orm';
import Model from '../base-model';
import { quizActions } from './quiz.action';
import quizReducers from './quiz.reducer';

/**
 * Teacher
 * @typedef {Object} Quiz
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {boolean} isAnswered
 * @property {Question[]} questions
 */

export class Quiz extends Model {

    toString() {
        return `Quiz: ${this.title}`
    }
}

Quiz.modelName = 'Quiz';

Quiz.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    isAnswered: attr(),
    grade: attr(),
    correctCount: attr(),
    wrongCount: attr(),
    notAnsweredCount: attr(),
    questions: many('Question', 'quiz'),
}


/**
 * QuizOverview
 * @typedef {Object} Quiz
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} status
 * @property {number} questionCount
 * @property {number} correctAnswer
 * @property {Unit} unit
 */
export class QuizOverview extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case quizActions.saveQuiz:
            quizReducers.saveQuiz(session, action.quiz);
            break;
        case quizActions.removeQuiz:
            quizReducers.removeQuiz(session, action.id);
            break;
        case quizActions.saveOverview:
            quizReducers.saveOverview(session, action.overview, action.courseId);
            break;
        case quizActions.clearOverviews:
            quizReducers.clearOverviews(session);
            break;
        case quizActions.setQuizProgress:
            quizReducers.setQuizProgress(
                session,
                action.id,
                action.grade,
                action.correctCount,
                action.wrongCount,
                action.notAnsweredCount,
            )
            break;
        default:
            return undefined;
        }
    }
    
    toString() {
        return `QuizOverview ${this.title}`;
    }
}

QuizOverview.modelName = 'QuizOverview';

QuizOverview.fields = {
    title: attr(),
    description: attr(),
    status: attr(),
    questionCount: attr(),
    correctAnswer: attr(),
    time: attr(),
    unit: oneToOne('Unit', 'quizOverview'),
    course: fk('Course', 'quizzesOverview'),
}